<template>
	<div class="db2-divider">
		<span v-if="label">{{ label }}</span>
	</div>
</template>

<script>
/**
 * Horizontal section divider.
 */
export default {
	name: 'DividerCard',
	props: {
		card: { type: Object, required: true },
		timePeriod: { type: String, default: 'week' }
	},
	computed: {
		/**
		 * Optional label.
		 * @returns {string}
		 */
		label() {
			return (this.card.config && this.card.config.label) || '';
		}
	}
};
</script>
